export default __webpack_public_path__ + "static/media/trash.e48ee052.svg";